import { FakeMemberRepository } from 'src/api/fake_member_repository';
import { MemberRepository } from 'src/api/member_repository';
import { UserFieldsFragment, RoleFieldsFragment } from 'src/types';
import { DistributionPlatform } from 'src/types/env';

const MEMBERS_STORAGE_KEY = 'samdMembers';
const INVITES_STORAGE_KEY = 'samdInvites';

const CLINIC_ADMIN_ROLE: RoleFieldsFragment = {
  id: 'role_1',
  name: 'clinic-admin',
  description: 'Admin user that can manage orders and members.',
};

const CLINIC_USER_ROLE: RoleFieldsFragment = {
  id: 'role_2',
  name: 'clinic-user',
  description: 'User that can manage orders.',
};

const user1 = {
  userId: 'user_123456',
  email: 'john.doe@example.com',
  name: 'John Doe',
  givenName: 'John',
  familyName: 'Doe',
  roles: [CLINIC_ADMIN_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user2 = {
  userId: 'user_234567',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user3 = {
  userId: 'user_234568',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user4 = {
  userId: 'user_234569',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user5 = {
  userId: 'user_234510',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user6 = {
  userId: 'user_234511',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user7 = {
  userId: 'user_234512',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user8 = {
  userId: 'user_234513',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user9 = {
  userId: 'user_234514',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user10 = {
  userId: 'user_234515',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user11 = {
  userId: 'user_234516',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user12 = {
  userId: 'user_234517',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user13 = {
  userId: 'user_234518',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user14 = {
  userId: 'user_234519',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user15 = {
  userId: 'user_234520',
  email: 'jane.smith@example.com',
  name: 'Jane Smith',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const user16 = {
  userId: 'user_234521',
  email: 'jane.smith@example.com',
  name: 'Hello World',
  givenName: 'Jane',
  familyName: 'Smith',
  roles: [CLINIC_USER_ROLE],
  lab: null,
  sites: [],
  phoneNumber: null,
  picture: null,
} satisfies UserFieldsFragment;

const invitation1 = {
  id: 'inv_123456',
  email: 'new.user@example.com',
  expiresAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago (expired)
  createdAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(), // Created 9 days ago
  inviterName: 'John Doe',
  organizationId: 'org_123',
  roles: [CLINIC_USER_ROLE],
};

/**
 * Implementation of the Member Repository for the Samd platform on a fake backend.
 */
export class SamdFakeMemberRepository
  extends FakeMemberRepository
  implements MemberRepository
{
  readonly _platform = DistributionPlatform.Samd;
  readonly _roles = [CLINIC_ADMIN_ROLE, CLINIC_USER_ROLE];
  readonly _membersStorageKey = MEMBERS_STORAGE_KEY;
  readonly _invitationsStorageKey = INVITES_STORAGE_KEY;
  readonly _initialMembers = [
    user1,
    user2,
    user3,
    user4,
    user5,
    user6,
    user7,
    user8,
    user9,
    user10,
    user11,
    user12,
    user13,
    user14,
    user15,
    user16,
  ];
  readonly _initialInvitations = [invitation1];

  async getAssignableRoles(): Promise<RoleFieldsFragment[]> {
    return [CLINIC_ADMIN_ROLE, CLINIC_USER_ROLE];
  }
}
